module.exports = __webpack_public_path__ + "img/participate_award_banner_nl_2024.cb3ee174.png";